module.exports = __webpack_public_path__ + "img/aws-partner-icon-light.f4bcedf.svg";